.section {
  margin: auto;
  max-width: 1200px;
  width: 100%;
}
